/**
 * @description: 艺人台费流水汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="wr-ytlh-report">
        <div class="ytls-list">
            <p class="p-hint">注：退款金额是指退回用户充值时所用的银行卡或微信/支付宝余额，账户退回金额是指退回用户在巨嗨佳人台费账户的余额里，账户余额为艺人台费账户的实时余额。</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="ytlsTime">
                        <input type="text" class="form-control laydate-icon" v-model="ytlsStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="ytlsEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ytlsShop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-2">艺人:</label>
                <div class="col-md-2">
                    <input type="text" class="form-control" v-model="ytls_user" placeholder="请输入艺人姓名">
                </div>
                <label class="list-label-2">组别:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择组别" v-model="ytls_group_txt" ref="ytls_group_txt" readonly @click="ytlsEnterGroup">
                    <span class="selection-clear">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-2">主管:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ytls_charger" data-placeholder="请选择主管"></select>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitYtlsTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getYtlsExportSet">导出</button>
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">充值小计:</label>
                <div class="list-total" ref="ytls_in_amount"></div>
                <label class="list-label-5">扣台费小计:</label>
                <div class="list-total" ref="ytls_disc_amount"></div>
                <label class="list-label-4">退款小计:</label>
                <div class="list-total" ref="ytls_refund_amount"></div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="ytlsList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="ytlsExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='ytlsExport_allcheck' @click='ytlsExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytlsExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytlsExport_checkModel' value="pson_group_name">
                            <label>组别</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytlsExport_checkModel' value="pson_stage_name">
                            <label>艺人姓名</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytlsExport_checkModel' value="pson_director_name">
                            <label>主管</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytlsExport_checkModel' value="charge_amount">
                            <label>充值金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytlsExport_checkModel' value="cut_charge_amount">
                            <label>扣费金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytlsExport_checkModel' value="refund_charge_amount">
                            <label>退款金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytlsExport_checkModel' value="refund_cut_charge_amount">
                            <label>账户退回金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ytlsExport_checkModel' value="balance">
                            <label>账户余额</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='ytlsExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='ytlsExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 组别列表 -->
        <div class="ytls-group">
            <h3>请选择组别</h3>
            <div class="group-search pull-right">
                <input type="text" placeholder="请输入组别名称" v-model="ytls_group_name">
                <img src="../../../assets/images/group_search.png" @click="getYtlsGroupData">
            </div>
            <!-- 列表 -->
            <div class="group-list">
                <ul class="clearfix">
                    <li>
                        <input type='checkbox' v-model='ytls_group_allcheck' @click='groupYtlsCheckedAll'>
                        <label>全部组别</label>
                    </li>
                    <li v-for="item in ytls_group_checkboxData" :key="item.group_id">
                        <input type="checkbox" v-model='ytls_group_checkboxModel' :value='item.group_id'>
                        <label>{{item.group_name}}</label>
                    </li>
                </ul>
            </div>
            <div class="row" style="padding-top: 30px;">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="ytlsGroupBack()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;" @click="ytlsGroupSub()">确定</button>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                ytlsStartTime: "",
                ytlsEndTime: "",
                ytls_user: '',
                ytls_group_txt: "",
                ytls_group_allcheck: false,
                ytls_c_group_allcheck: false,
                ytls_group_checkboxModel: [],
                c_ytls_group_checkboxModel: [],
                ytls_group_checkboxData: [],
                ytls_group_name: '',
                ytlsExport_allcheck: false,
                c_ytlsExport_allcheck: false,
                ytlsExport_checkModel: [],
                ytlsExport_checkData: ['shop_name', 'create_time', 'stage_name', 'amount', 'refund_amount'],
                ytlsExport_type: 1,
            }
        },
        watch: {
            ytls_group_checkboxModel: {
                handler: function(val, oldVal) {
                    if(this.ytls_group_checkboxModel.length >= this.ytls_group_checkboxData.length) {
                        this.ytls_group_allcheck = true;
                        this.ytls_c_group_allcheck = true;
                    } else {
                        this.ytls_group_allcheck = false;
                        this.ytls_c_group_allcheck = false;
                    }
                },
                deep: true
            },
            ytlsExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.ytlsExport_checkModel.length >= this.ytlsExport_checkData.length) {
                        this.ytlsExport_allcheck = true;
                        this.c_ytlsExport_allcheck = true;
                    } else {
                        this.ytlsExport_allcheck = false;
                        this.c_ytlsExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.ytlsStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.ytlsEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.ytlsStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ytlsEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.ytlsStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.ytlsEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.ytlsTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.ytlsStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.ytlsEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.ytlsShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.ytls_group_checkboxModel = [];
                                _this.ytls_group_txt = '';
                                if(e.params.data.text == "全部") {
                                    // 主管
                                    $(_this.$refs.ytls_charger).val('').trigger('change');
                                    $(_this.$refs.ytls_charger).prop("disabled", true);
                                    return;
                                }
                                // 主管
                                $(_this.$refs.ytls_charger).prop("disabled", false);
                                _this.getChargeData(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.ytlsShop).val(data.response.result[1].id).trigger('change');
                            // 主管
                            $(_this.$refs.ytls_charger).prop("disabled", false);
                            _this.getChargeData(data.response.result[1].id);
                            _this.setShopDefaultTime(data.response.result[1].id);
                            _this.innitYtlsTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取主管
            getChargeData: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getDirectorSearchList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let arr = [{ id: ' ', text: '全部', type: '' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name, type: v.type });
                            });
                            $(_this.$refs.ytls_charger).html('');
                            $(_this.$refs.ytls_charger).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            })
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('网络错误');
                    }
                });
            },



            // 进入选择组别
            ytlsEnterGroup: function() {
                this.c_ytls_group_checkboxModel = this.ytls_group_checkboxModel;
                this.ytls_group_checkboxModel = [];
                this.getYtlsGroupData();
                this.ytls_group_checkboxModel = this.c_ytls_group_checkboxModel;
                $('.ytls-list').hide();
                $('.ytls-group').show();
            },
            // 获取组别列表
            getYtlsGroupData: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": '0',
                            "page_size": '0',
                            "shop_id": $(_this.$refs.ytlsShop).val(),
                            "key_word": 'personnel',
                            "group_name": _this.ytls_group_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGroupSearchList",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.ytls_group_checkboxData = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 全选
            groupYtlsCheckedAll: function() {
                let _this = this;
                _this.ytls_group_allcheck = _this.ytls_c_group_allcheck;
                if(!_this.ytls_group_allcheck) { // 实现全选
                    _this.ytls_group_checkboxModel = [];
                    _this.ytls_group_checkboxData.forEach(function(item) {
                        _this.ytls_group_checkboxModel.push(item.group_id);
                    });
                } else { // 实现反选
                    _this.ytls_group_checkboxModel = [];
                }
            },
            // 返回
            ytlsGroupBack: function() {
                $('.ytls-group').hide();
                $('.ytls-list').show();
                this.ytls_group_checkboxModel = this.c_ytls_group_checkboxModel;
            },
            ytlsGroupSub: function() {
                let _this = this;
                let arr = [];
                _this.ytls_group_checkboxData.forEach(function(item) {
                    _this.ytls_group_checkboxModel.forEach(function(sub) {
                        if(item.group_id == sub) {
                            arr.push(item.group_name);
                        }
                    });
                });
                _this.ytls_group_txt = arr.join(',');
                $('.ytls-group').hide();
                $('.ytls-list').show();
            },
            // 表格
            innitYtlsTable: function() {
                let _this = this;
                $(_this.$refs.ytlsList).bootstrapTable('destroy');
                $(_this.$refs.ytlsList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYtlsList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "6%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "130",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "pson_group_name",
                        title: "组别",
                        width: "10%"
                    }, {
                        field: "pson_stage_name",
                        title: "艺人姓名",
                        width: "10%"
                    }, {
                        field: "pson_director_name",
                        title: "主管",
                        width: "10%"
                    }, {
                        field: "charge_amount",
                        title: "充值金额",
                        width: "10%"
                    }, {
                        field: "cut_charge_amount",
                        title: "扣费金额",
                        width: "10%"
                    }, {
                        field: "refund_charge_amount",
                        title: "退款金额",
                        width: "10%"
                    }, {
                        field: "refund_cut_charge_amount",
                        title: "账户退回金额",
                        width: "10%"
                    }, {
                        field: "balance",
                        title: "账户余额",
                        width: "10%"
                    }],
                });
            },
            // 数据
            getYtlsList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.ytlsStartTime,
                            "end_time": _this.ytlsEndTime,
                            "shop_id": $(_this.$refs.ytlsShop).val(),
                            "pson_stage_name": _this.ytls_user,
                            "group_id": _this.ytls_group_checkboxModel,
                            "pson_director_uid": $.trim($(_this.$refs.ytls_charger).val())
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport2/personnelChargeLog",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                            $(_this.$refs.ytls_in_amount).text(data.response.result.charge_amount_total);
                            $(_this.$refs.ytls_disc_amount).text(data.response.result.cut_charge_amount_total);
                            $(_this.$refs.ytls_refund_amount).text(data.response.result.refund_charge_amount_total);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getYtlsExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/personnelChargeLogExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.ytlsExport_checkModel = data.response.result.export_fields;
                                _this.ytlsExport_type = data.response.result.export_type;
                            } else {
                                _this.ytlsExport_checkModel = _this.ytlsExport_checkData;
                                _this.ytlsExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.ytlsExport_alert)
                }, function() {
                    _this.exportYtlsList();
                });
            },
            // 导出字段全选
            ytlsExportCheckedAll: function() {
                let _this = this;
                _this.ytlsExport_allcheck = _this.c_ytlsExport_allcheck;
                if(!_this.ytlsExport_allcheck) { // 实现全选
                    _this.ytlsExport_checkModel = [];
                    _this.ytlsExport_checkData.forEach(function(item) {
                        _this.ytlsExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.ytlsExport_checkModel = [];
                }
            },
            // 导出
            exportYtlsList: function() {
                let _this = this;
                let export_fields = JSON.stringify(_this.ytlsExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport2/personnelChargeLogExport?" +
                    "&start_time=" + _this.ytlsStartTime +
                    "&end_time=" + _this.ytlsEndTime +
                    "&shop_id=" + $(_this.$refs.ytlsShop).val() +
                    "&pson_stage_name=" + _this.ytls_user +
                    "&group_id=" + _this.ytls_group_checkboxModel +
                    "&pson_director_uid=" + $.trim($(_this.$refs.ytls_charger).val()) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.ytlsExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    /* 组别 */
    .ytls-group {
        display: none;
        .group-search {
            position: relative;
            margin: 0 0 30px;
            input {
                width: 300px;
                height: 36px;
                padding: 0 45px 0 16px;
                color: #888;
                font-size: 16px;
                background: #f5f5f5;
                border-radius: 6px;
            }
            img {
                position: absolute;
                right: 10px;
                top: 6px;
                width: 24px;
                cursor: pointer;
            }
            button {
                margin: 0 30px 0 0;
            }
        }
        .group-list {
            clear: both;
            li:first-child {
                width: 100%;
                input {
                    margin: 2px 10px 0 0;
                }
            }
            li {
                float: left;
                width: 20%;
                margin: 0 0 30px;
                font-size: 14px;
                input {
                    float: left;
                    margin: 2px 10px 0 30px;
                }
                label {
                    margin: 0;
                    font-weight: normal;
                }
            }
        }
        .row {
            button {
                margin: 0 30px 0 0;
            }
        }
    }
</style>